import { BasicLayout } from '@/components/layouts';

export default {
  path: '/wenjuan',
  name: 'wenjuan',
  component: BasicLayout,
  redirectToChild: true,
  hiddenInMenu: true,
  meta: {
    title: '问卷',
    icon: 'database',
  },
  children: [
    {
      path: '/wenjuan/list',
      name: 'Wenjuan.List',
      component: () => import(/* webpackChunkName: "form" */ '@/views/modules/wenjuan/List.vue'),
      meta: {
        title: '问卷列表',
      },
    },
  ],
};
